import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_AdvisorStatic } from '../ModuleFE_AdvisorStatic.js';
import { DBDef_EHRInstallation, DBDef_Environment, DBDef_Facility, DBDef_OrderConfiguration, DBDef_Organization } from '@app/org-shared';
export const dispatch_onOrganizationChanged = new ThunderDispatcherV3('__onOrganizationUpdated');
class ModuleFE_Advisor_Organization_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_Organization, dispatch_onOrganizationChanged);
    }
}
export const ModuleFE_Advisor_Organization = new ModuleFE_Advisor_Organization_Class();
export const dispatch_onEHRInstallationChanged = new ThunderDispatcherV3('__onEHRInstallationUpdated');
class ModuleFE_Advisor_EHRInstallation_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_EHRInstallation, dispatch_onEHRInstallationChanged);
    }
}
export const ModuleFE_Advisor_EHRInstallation = new ModuleFE_Advisor_EHRInstallation_Class();
export const dispatch_onFacilityChanged = new ThunderDispatcherV3('__onFacilityUpdated');
class ModuleFE_Advisor_Facility_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_Facility, dispatch_onFacilityChanged);
    }
}
export const ModuleFE_Advisor_Facility = new ModuleFE_Advisor_Facility_Class();
export const dispatch_onEHREnvironmentChanged = new ThunderDispatcherV3('__onEHREnvironmentUpdated');
class ModuleFE_Advisor_EHREnvironment_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_Environment, dispatch_onEHREnvironmentChanged);
    }
}
export const ModuleFE_Advisor_EHREnvironment = new ModuleFE_Advisor_EHREnvironment_Class();
export const dispatch_onOrderConfiguration = new ThunderDispatcherV3('__onOrderConfigUpdated');
class ModuleFE_Advisor_OrderConfiguration_Class extends ModuleFE_AdvisorStatic {
    constructor() {
        super(DBDef_OrderConfiguration, dispatch_onOrderConfiguration);
    }
}
export const ModuleFE_Advisor_OrderConfiguration = new ModuleFE_Advisor_OrderConfiguration_Class();
// ##################### Module Pack #####################
export const ModulePack_Static_Organization = [
    ModuleFE_Advisor_Organization,
    ModuleFE_Advisor_Facility,
    ModuleFE_Advisor_EHREnvironment,
    ModuleFE_Advisor_EHRInstallation,
    ModuleFE_Advisor_OrderConfiguration,
];
//# sourceMappingURL=organization.js.map